/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skipped_CardInputs */

const vi_einvoice_skipped_card = /** @type {(inputs: Einvoice_Skipped_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xuất hóa đơn cho đơn này.`)
};

/**

* @param {Einvoice_Skipped_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skipped_card = /** @type {((inputs?: Einvoice_Skipped_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skipped_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skipped_card(inputs)
});